var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33138 13.4974C1.33138 14.4141 2.08138 15.1641 2.99805 15.1641H9.66471C10.5814 15.1641 11.3314 14.4141 11.3314 13.4974V3.4974H1.33138V13.4974ZM2.99805 5.16406H9.66471V13.4974H2.99805V5.16406ZM9.24805 0.997396L8.41471 0.164062H4.24805L3.41471 0.997396H0.498047V2.66406H12.1647V0.997396H9.24805Z",
    fill: "#2F736E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0344d5c661bdbd2d8bdc50e458c3c226.svg";
export { ForwardRef as ReactComponent };